const cities = [
  { key: "Auckland", value: "Auckland" },
  { key: "Blenheim", value: "Blenheim" },
  { key: "Christchurch", value: "Christchurch" },
  { key: "Dunedin", value: "Dunedin" },
  { key: "Gisborne", value: "Gisborne" },
  { key: "Hamilton", value: "Hamilton" },
  { key: "Hastings", value: "Hastings" },
  { key: "Invercargill", value: "Invercargill" },
  { key: "Napier", value: "Napier" },
  { key: "Nelson", value: "Nelson" },
  { key: "New Plymouth", value: "New Plymouth" },
  { key: "Palmerston North", value: "Palmerston North" },
  { key: "Porirua", value: "Porirua" },
  { key: "Pukekohe", value: "Pukekohe" },
  { key: "Rotorua", value: "Rotorua" },
  { key: "Tauranga", value: "Tauranga" },
  { key: "Timaru", value: "Timaru" },
  { key: "Wellington", value: "Wellington" },
  { key: "Whanganui", value: "Whanganui" },
  { key: "Whangārei", value: "Whangārei" }
];

export default cities;